var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22012_82109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41176 15.1579H2.64706C2.21023 15.1579 1.7913 14.9805 1.48241 14.6646C1.17353 14.3487 1 13.9204 1 13.4737V3.36842C1 2.92174 1.17353 2.49336 1.48241 2.1775C1.7913 1.86165 2.21023 1.68421 2.64706 1.68421H12.5294C12.9662 1.68421 13.3852 1.86165 13.6941 2.1775C14.0029 2.49336 14.1765 2.92174 14.1765 3.36842V5.89474M10.8824 0V3.36842M4.29412 0V3.36842M1 6.73684H11.2941M15 10.1053H12.9412C12.6136 10.1053 12.2994 10.2383 12.0677 10.4752C11.836 10.7121 11.7059 11.0334 11.7059 11.3684C11.7059 11.7034 11.836 12.0247 12.0677 12.2616C12.2994 12.4985 12.6136 12.6316 12.9412 12.6316H13.7647C14.0923 12.6316 14.4065 12.7647 14.6382 13.0016C14.8699 13.2384 15 13.5597 15 13.8947C15 14.2297 14.8699 14.551 14.6382 14.7879C14.4065 15.0248 14.0923 15.1579 13.7647 15.1579H11.7059M13.3529 15.1579V16M13.3529 9.26316V10.1053",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22012_82109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDollar);
export default __webpack_public_path__ + "static/media/calendar-dollar.57d41400e5d6a0c5ae6ecfc55ff0e5da.svg";
export { ForwardRef as ReactComponent };